import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';

import * as ServiceModels from '../../models/services/service';
import { ServiceSearchModel } from '../../models/services/serviceSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as Models from '../../models/commonModels';


@Injectable({
  providedIn: 'root'
})

export class ServiceService {

  constructor(private httpClient: HttpClient,
    private environment: EnvironmentService
  ) { }

  public getServiceTypeDictionary() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');


    const options = { headers: httpHeaders };
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<ServiceModels.ServiceTypeDictionaryListModel>(`${this.environment.getApiURL()}/service/type/list`, options);
  }


  public getList(Search: ServiceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };
    return this.httpClient.post<ServiceModels.ServiceListModel>(`${this.environment.getApiURL()}/service/list`, Search, options);
  }

  public get(ServiceId: number) {
    return this.httpClient.get<ServiceModels.ServiceObjectModel>(`${this.environment.getApiURL()}/service/get/${ServiceId}`);
  }


  public delete(ServiceId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<HttpEventType>(`${this.environment.getApiURL()}/service/delete/${ServiceId}`, options);
  }



  public duplicate(ServiceId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<HttpEventType>(`${this.environment.getApiURL()}/service/duplicate/${ServiceId}`, options);
  }

  public insertNew(NewService: ServiceModels.ServiceModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.post<ServiceModels.ServiceModel>(
      `${this.environment.getApiURL()}/service/insert`, NewService, options);
  }

  public set(Service: ServiceModels.ServiceModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<ServiceModels.ServiceModel>(`${this.environment.getApiURL()}/service/set`, Service, options);
  }

  public setCommision(Commission: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<ServiceModels.ServiceModel>(`${this.environment.getApiURL()}/service/set/commission`, { NotDefinePriceServiceCommission: Commission }, options);
  }


  public getCustomerGarageServicePriceList(Search: ServiceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };
    return this.httpClient.post<Models.Response<ServiceModels.CustomerGarageServicePriceModel[]>>(`${this.environment.getApiURL()}/service/customer/garage/price/list`, Search, options);
  }

  public setCustomerGarageServicePrice(ServiceList: Models.Request<ServiceModels.SetCustomerGarageServicePriceModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseBase>(`${this.environment.getApiURL()}/service/customer/garage/price/set`, ServiceList, options);
  }

  public getGarageServicePriceExcelReport(search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environment.getApiURL()}/service/garage/price/report-excel`,
      search,
      options
    );
  }

  public getGarageServicePricePdfReport(search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environment.getApiURL()}/service/garage/price/report-pdf`,
      search,
      options
    );
  }


  public importGarageServicePrice(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environment.getApiURL()}/service/garage/price/import`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }
   
  public sendEmailGarageServicePricePdfReport(search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<any>(
      `${this.environment.getApiURL()}/service/garage/price/pdf-email`,
      search,
      options
    );
  }

  public clearCustomerGarageServicePrice(Search: ServiceModels.CustomerGarageServicePriceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseBase>(`${this.environment.getApiURL()}/service/customer/garage/price/clear`, Search, options);
  }

  public GetGarageServicePriceAnalyticExcelReport(search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environment.getApiURL()}/service/garage/price/price-analytic-report-excel`,
      search,
      options
    );
  }
}
